import React from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";
import "./logic.css";
import { withTranslation } from "react-i18next";
import FeatureUnavailable from "../../../Subscriptions/FeatureUnavailable";
import { websiteUrl } from "../../../../config";
import ConditionLine from "./ProductConditionLine";
import ProductConditions from "./ProductConditions";

class ProductsLogicModal extends React.Component {
  state = {
    show: this.props.isShow,
    logic: {},
    logics: [],
    stepId: null,
    isPermited: true,
  };

  componentDidMount() {
    const { productsLogic = {} } = this.props;
    let { id, options, inputs: contacts } = this.props.step;
    const stepLogic = productsLogic[id] || [];

    const { arrayOfData, permitions } = this.props;
    options = options ? options : [];
    contacts = contacts ? contacts : [];

    const allContacts = arrayOfData.reduce((obj, step) => {
      if (step.type !== "contact") return obj;
      step.inputs.forEach((input) => {
        obj[input.name] = input;
      });
      return obj;
    }, {});
    this.setState({
      logics: JSON.parse(JSON.stringify(stepLogic)),
      allContacts,
      options,
      permitions,
      stepId: id,
    });
    return;
  }

  componentDidUpdate(prevProps) {
    const { productsLogic = {} } = this.props;
    const { id } = this.props.step;
    const stepLogic = productsLogic[id] || [];
    if (
      JSON.stringify(prevProps.productsLogic) !== JSON.stringify(productsLogic)
    ) {
      this.setState({ logics: stepLogic });
    }
  }

  handleClose = () => {
    let { productsLogic = {} } = this.props;
    const { id } = this.props.step;
    productsLogic = JSON.parse(JSON.stringify(productsLogic));
    this.props.resetLogics();
    this.setState({ logics: productsLogic[id] || [], show: false });
  };

  handleSave = () => {
    const { stepId, logics = [] } = this.state;
    const { productsLogic } = this.props;
    console.log(logics, this.props.productsLogic[stepId]);
    if (
      JSON.stringify(logics) !==
      JSON.stringify(this.props.productsLogic[stepId])
    ) {
      this.props.saveProductsLogics({ ...productsLogic, [stepId]: logics });
    }

    this.handleClose();
  };

  handleReset = () => {
    //Check!
    let { logics } = this.props.step;
    if (JSON.stringify(logics) !== JSON.stringify(this.props.step.logics)) {
      logics = JSON.parse(JSON.stringify(logics));
      this.setState({ logics });
    }
    this.handleClose();
  };

  addRule = (logicIndex) => {
    const { logics } = this.state;

    const conditionObj = {
      id: `L${Math.random() * 9999999}`,
      conditionCase: "",
      sectionId: "UTM_Source",
      operation: "==",
      value: "",
      operator: "&&",
      validationType: "UTM",
      then: "product",
      to: "",
      redirectUrl: websiteUrl,
    };
    logics[logicIndex].conditions.push(conditionObj);
    this.setState({ logics });
  };

  addNewLogic = (position) => {
    const { logics = [] } = this.state;
    logics.push({
      conditions: [
        {
          id: `L${Math.random() * 9999999}`,
          conditionCase: "",
          sectionId: "UTM_Source",
          operation: "==",
          value: "",
          validationType: "UTM",
          then: "product",
          to: "",
          redirectUrl: websiteUrl,
        },
      ],
      then: "product",
      to: "",
    });
    this.setState({ logics });
  };

  handleContactList = () => {
    const { arrayOfData } = this.props;
    return Object.values(
      arrayOfData.reduce((obj, step) => {
        if (step.type !== "contact") return obj;
        step.inputs.forEach((input) => {
          input.slideName = step.slideName;
          if (input.type === "location") {
            input.inputs.forEach((itr) => {
              itr.slideName = step.slideName;
              if (itr.show) obj[itr.name] = itr;
            });
          } else obj[input.name] = input;
        });
        return obj;
      }, {})
    );
  };

  handleStepLogic = (
    e,
    selectedConditionPosition,
    conditionIndex,
    logicIndex
  ) => {
    const { logics } = this.state;
    const { name, value } = e.target;
    logics[logicIndex].conditions[conditionIndex][name] = value;
    const validationType =
      e.target.tagName === "SELECT"
        ? e.target.options[e.target.selectedIndex].parentNode.label
        : null;
    if (validationType) {
      logics[logicIndex].conditions[conditionIndex].validationType =
        validationType;
      logics[logicIndex].conditions[conditionIndex].operation = "==";
      logics[logicIndex].conditions[conditionIndex].value = "";
    }
    this.setState({ logics });
  };

  removeConditionFromStep = (
    logicIndex,
    conditionIndex,
    selectedConditionPosition
  ) => {
    const { logics } = this.state;
    logics[logicIndex].conditions.splice(conditionIndex, 1);
    this.setState({ logics });
  };

  handleLogicDetails = (e, logicIndex, position) => {
    const { name, value } = e.target;
    const { logics } = this.state;
    logics[logicIndex][name] = value;
    this.setState({ logics });
  };

  removeLogic = (logicIndex, selectedConditionPosition) => {
    const { logics } = this.state;
    logics.splice(logicIndex, 1);
    this.setState({ logics });
  };

  showConditions = (step, logic, selectedConditionPosition, logicIndex) => {
    const { arrayOfData, variables = [], feedProducts = [] } = this.props;

    const matrixOptions = arrayOfData.reduce((array, itr) => {
      if (itr.type != "question") {
        return array;
      }
      const { slideName } = itr;
      if (itr.questionType == "matrix") {
        itr.matrix.rows.forEach((row) => {
          array.push({
            title: `${slideName} -> ${row.value.replace(/(<([^>]+)>)/gi, "")}`,
            id: row.id,
          });
        });
      }
      return array;
    }, []);
    return logic.conditions.map((condition, conditionIndex) => {
      const { t } = this.props;
      const { allContacts = {} } = this.state;
      const {
        id,
        type,
        sectionId,
        operation,
        conditionCase,
        validationType,
        value,
        operator,
      } = condition;

      let currentStep = arrayOfData.find((itr) => itr.id == sectionId);
      if (validationType == "Questions" && !currentStep) return <></>;
      if (validationType == "Matrix") {
        currentStep = arrayOfData.find(
          (itr) =>
            itr.questionType == "matrix" &&
            itr.matrix.rows.find((row) => row.id == sectionId)
        );
      }

      return (
        <div key={id} className="d-flex">
          <div key={id} className=" d-flex col-2">
            {conditionIndex ? (
              <div>
                <select
                  name="operator"
                  value={operator}
                  className="form-control product-logic-input"
                  onChange={(e) =>
                    this.handleStepLogic(
                      e,
                      selectedConditionPosition,
                      conditionIndex,
                      logicIndex
                    )
                  }
                >
                  <option value={"&&"}>
                    {t("leftBar-welcome-logicModal-and")}
                  </option>
                  <option value={"||"}>
                    {t("leftBar-welcome-logicModal-or")}
                  </option>
                </select>
              </div>
            ) : (
              // <></>
              <label className="">
                {t("leftBar-welcome-logicModal-response-to")}
              </label>
            )}
          </div>
          <div
            className="d-flex col-9 row"
            style={{ maxHeight: "219px", minHeight: "60px" }}
          >
            <div className="col-4">
              <select
                name="sectionId"
                className="form-control product-logic-input"
                value={sectionId}
                onChange={(e) =>
                  this.handleStepLogic(
                    e,
                    selectedConditionPosition,
                    conditionIndex,
                    logicIndex
                  )
                }
              >
                <option value="" disabled>
                  {t("leftBar-welcome-logicModal-select")}
                </option>
                <optgroup label="Questions">
                  {arrayOfData.map((itr, index) => {
                    if (itr.type != "question" || itr.questionType == "matrix")
                      return <></>;

                    return (
                      <option key={itr.id} value={itr.id}>
                        {itr.slideName}
                      </option>
                    );
                  })}
                </optgroup>
                <optgroup label="Matrix">
                  {matrixOptions.map((itr, index) => {
                    return (
                      <option key={itr.id} value={itr.id}>
                        {itr.title}
                      </option>
                    );
                  })}
                </optgroup>
                <optgroup label="Variables">
                  {variables.map((variable, index) => {
                    const { name, type } = variable;
                    if (type == "UTM") return <></>;
                    return (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    );
                  })}
                </optgroup>
                <optgroup label="UTM">
                  {variables.map((variable, index) => {
                    const { name, type } = variable;
                    if (type != "UTM") return <></>;
                    return (
                      <option key={index} value={name}>
                        {name}
                      </option>
                    );
                  })}
                </optgroup>
                <optgroup label="Form Answers">
                  {this.handleContactList().map((variable) => {
                    const { label, name, slideName } = variable;
                    return (
                      <option key={name} value={label}>
                        {`${slideName} ->`} {label}
                      </option>
                    );
                  })}
                </optgroup>
                <optgroup label="System">
                  <option key={"score"} value={"score"}>
                    {"score"}
                  </option>
                </optgroup>
              </select>
            </div>
            <ConditionLine
              handleStepLogic={this.handleStepLogic}
              selectedConditionPosition={selectedConditionPosition}
              conditionIndex={conditionIndex}
              logicIndex={logicIndex}
              operation={operation}
              currentStep={currentStep}
              t={t}
              value={value}
              conditionType={
                currentStep && validationType == "Questions"
                  ? currentStep.questionType
                  : validationType
              }
              sectionId={sectionId}
              contacts={allContacts}
              score={this.props.score}
              feedProducts={feedProducts}
            />
          </div>

          {logic.conditions.length !== 1 && (
            <div className="col-1 d-flex justify-content-between">
              {/* <a title="" className="down"></a> */}
              <a
                title=""
                className="trash"
                onClick={() =>
                  this.removeConditionFromStep(
                    logicIndex,
                    conditionIndex,
                    selectedConditionPosition
                  )
                }
              ></a>
            </div>
          )}
        </div>
      );
    });
  };

  changeLogicsDefaultRedirect = (moveToStep, position) => {
    const { logics } = this.state;
    const { otherCasesRedirect = { after: "", before: "" } } = logics;
    otherCasesRedirect[position] = moveToStep;
    logics.otherCasesRedirect = otherCasesRedirect;
    this.setState({ logics });
  };

  render() {
    const { quizType, feedProducts = [] } = this.props;
    let { id } = this.props.step;
    const { logics } = this.state;

    // const logics = this.props;
    let { t } = this.props;

    if (quizType !== "ecom") return <></>;

    if (!this.state.isPermited) {
      return (
        <>
          <FeatureUnavailable
            isShow="true"
            hide={() => this.setState({ isPermited: true })}
            feature="logic"
          />
        </>
      );
    }
    return (
      <>
        <Dropdown.Item
          // active
          // disabled={!this.props.permitions.logics}
          // color="danger"

          onClick={() => {
            if (!this.props.permitions.logics)
              return this.setState({ isPermited: false });
            this.props.getStepLogic(this.props.quizId, id);
            this.setState({ show: true });
          }}
        >
          <i className="bi bi-cart2 left-bar-dropdown-item-icon"></i>
          {t("leftBar-dropdown-icons-logic-products")}
          {!this.props.permitions.logics ? (
            <i class="bi bi-lock-fill m-2"></i>
          ) : (
            <></>
          )}
        </Dropdown.Item>
        <Modal show={this.state.show} size="xl" onHide={this.handleClose}>
          <Modal.Header>
            {/* <Modal.Title className="logic"> */}
            <h2>{t("leftBar-welcome-logicModal-title")}</h2>{" "}
          </Modal.Header>
          <Modal.Body className="modal-logic">
            <ProductConditions
              {...this.props}
              changeLogicsDefaultRedirect={this.changeLogicsDefaultRedirect}
              removeLogic={this.removeLogic}
              handleLogicDetails={this.handleLogicDetails}
              removeConditionFromStep={this.removeConditionFromStep}
              handleStepLogic={this.handleStepLogic}
              handleContactList={this.handleContactList}
              addNewLogic={this.addNewLogic}
              addRule={this.addRule}
              showConditions={this.showConditions}
              logics={logics}
              customScripts={{}}
              feedProducts={feedProducts}
            />
          </Modal.Body>
          <Modal.Footer className="w-100 p-0">
            <div className="popupFooter justify-content-between">
              <div className="d-flex">
                <input
                  type="button"
                  value={t("general-cancel")}
                  onClick={this.handleClose}
                  className="btn-popup-cancel"
                />
                <span
                  className="close close_multi"
                  disabled={
                    JSON.stringify(logics) ===
                    JSON.stringify(this.props.step.logics)
                  }
                  onClick={this.handleReset}
                >
                  {t("leftBar-welcome-logicModal-reset")}
                </span>
              </div>

              <input
                type="button"
                value={t("leftBar-welcome-logicModal-save")}
                className={
                  JSON.stringify(logics) ===
                  JSON.stringify(this.props.step.logics)
                    ? "btn-popup-cancel"
                    : "btn-popup"
                }
                disabled={
                  JSON.stringify(logics) ===
                  JSON.stringify(this.props.step.logics)
                }
                onClick={this.handleSave}
              />
            </div>
            {/* </div> */}
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withTranslation()(ProductsLogicModal);
